//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { Enums } from '../../../models/common/enums'

import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { ALARM_GROUP_SERVICE_NAME, AlarmGroupService } from '../../../services/alarm-group/alarm-group.service'

//#region Asset Imports

import * as TEMPLATE from './alarm-group-create-edit-popup.tpl.html'
import { AlarmGroupCreateEditController } from './alarm-group-create-edit-popup.directive.controller';

//#endregion

export class AlarmGroupCreateEditDirective implements ng.IDirective {
    constructor() {
    }

    scope = {
        id: "="
    }
    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        ALARM_GROUP_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            alarmGroupService: AlarmGroupService,
        ) => new AlarmGroupCreateEditController(
            $scope,
            $q,
            $timeout,
            alarmGroupService,
            Enums.ReferenceType.IdAlarmGroup,
            Enums.SimaxModuleName.Alarm_Group
        )]

    controllerAs = "$ctrl"

    template = TEMPLATE

    transclude = true
}